import { createContext } from 'react'

const justContext = createContext()

export default justContext
